import { Typography } from "@mui/material";
import { StyledAgendaPage } from "./AgendaPage.styled";
import { Calandar } from "../../components/calandar/Calandar";

export const AgendaPage = () => {
  return (
    <StyledAgendaPage>
      <Typography variant="h1">Agenda</Typography>
      <Calandar />
    </StyledAgendaPage>
  );
};
